const PanelContainer = {
  baseStyle: {
    p: '0px 0px 0px 0px',
    minHeight: 'calc(100vh - 123px)',
  },
};

export const PanelContainerComponent = {
  components: {
    PanelContainer,
  },
};
